export enum TrackedEvents {
  ADD_TO_FILTERS = 'facts.stack.addToFiltersClicked',
  BROWSE_FEED = 'facts.stack.browseFeedClicked',
  CATEGORY_DETAIL_COLLAPSED = 'facts.stack.categoryDetailCollapsed',
  CATEGORY_DETAIL_EXPANDED = 'facts.stack.categoryDetailExpanded',
  CONTEXT_MENU_OPENED = 'facts.stack.contextMenuOpened',
  COPY_URL = 'facts.stack.copyUrlClicked',
  CREATE_ELEMENT = 'facts.stack.createElementClicked',
  EXTERNAL_LINK = 'facts.stack.externalLinkClicked',
  OPENED = 'facts.stack.opened',
  READ_MORE = 'facts.stack.readMoreClicked'
}

// Keys should match the appropriate FactActionType values
// (that enum can't be used here because it causes a cyclical build-time error)
export const TrackedRelatedActionEvents = {
  AddToFilter: 'facts.stackRelations.addToFilter',
  OpenInStack: 'facts.stackRelations.openInStack',
  SeeSignals: 'facts.stackRelations.seeSignals'
};
